<template>
  <div class="w-full h-full py-2">
    <div class="h-full md:px-8 overflow-hidden">
      <div class="w-full h-full flex">
        <div class="w-full h-full relative">
          <div class="flex flex-row w-full gap-2 absolute left-1">
            <router-link to="/" class="text-[14px] font-medium text-gray-500">{{ $t('accueil') }} ></router-link>
            <div href="" class="  text-[14px] font-bold text-gray-500">{{ $t('encheres') }} ></div>
          </div>
          <div class="w-full h-full flex justify-center">
            <div class="xl:w-[80%] w-[100%] flex flex-col relative h-full gap-4 ">
              <div class="w-full">
                <div class="flex justify-between">
                  <div class="mx-auto md:mx-0">
                    <div class="flex justify-center flex-1 ">
                      <div class="flex space-x-6">
                        <div class=" h-auto flex items-center">
                          <p class="md:text-[7rem] text-[6rem] font-semibold">{{ nbr < 10 && nbr > 0 ? '0' + nbr : nbr }}</p>
                        </div>
                        <div class=" h-auto flex items-center">
                          <div class="space-y-1 mt-4">
                            <div class="w-full flex justify-center md:block">
                              <p class="text-md font-semibold text-white bg-red-500 rounded-md p-1 w-min">{{ $t('live') }}</p>
                            </div>
                            <p class="lg:text-2xl md:text-lg text-xs text-center">{{ $t('enchereendirect') }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex px-2 md:px-0">
                      <form @submit.prevent="search" class="w-full flex space-x-2">
                        <input @keyup="searchRefresh" v-model="nameSearch" type="text"
                          class="h-full flex-1 bg-gray-100 border border-transparent rounded-lg  text-sm shadow-lg  focus:ring-[#FF9900] focus:border-[#FF9900] block  p-2  placeholder-gray-400 focus:outline-none transition duration-300"
                          :placeholder="$t('recherchez')" />
                        <select class="rounded-lg bg-gray-200 h-auto  px-5 outline-none shadow-lg">
                          <option class="text-bold">Douala</option>
                        </select>
                        <button class="h-10 w-10 rounded-full bg-[#FF9900] flex justify-center items-center shadow-2xl">
                          <img class=" w-4 h-4 mx-auto" src="/icons/search.png" alt="" srcset="">
                        </button>
                      </form>
                    </div>
                  </div>
                  <div class="flex-initial h-auto w-[10%] md:w-[30%] flex items-end absolute md:static right-0">
                    <img class="h-auto object-contain" src="/images/IMG_3460.jpg" alt="" srcset="">
                  </div>
                </div>
              </div>
              <div v-if="loadEnchere == false && encheres.length == 0" class="w-full h-full overflow-hidden space-y-2 flex items-center justify-center">
                <div class="relative">
                  <div class="h-auto flex justify-center">
                    <p class="text-gray-400 text-xl">{{ $t('aucunenchere') }}</p>
                  </div>
                </div>
              </div>
              <div v-if="loadEnchere" class="w-full h-full overflow-hidden space-y-2">
                <div v-for="i in 20" :key="i.id" class="w-full  bg px-4 flex justify-center items-center">
                  <!-- debut du cadre pour la presentation des swiper celui avec le shadow  -->
                  <div class="h-full w-full p-3 relative border rounded-md shadow-lg space-y-2">
                    <div class="w-full">
                      <div
                        class="w-full h-[100%]  rounded-t-md justify-start items-center flex xl:space-x-3 space-x-2">
                        <div class="flex relative w-full justify-between space-x-1">
                          <div class="flex space-x-2">
                            <div class="leading-5 pt-1 h-auto flex items-center">
                              <button class="w-16 h-8 animate-pulse bg-gray-400  font-semibold flex-auto my-auto text-white p-1 md:p-2 rounded-md text-[10px] xl:text-[18px]"></button>
                            </div>
                            <div class="pt-1 xl:leading-6 flex items-center h-auto leading-3 md:leading-4 ">
                              <div class="space-y-2">
                                <p class="w-32 md:w-56 h-2 animate-pulse bg-gray-400 font-semibold xl:text-[16px] text-[8px] md:text-[12px]"></p>
                                <p class="w-28 md:w-64 h-2 animate-pulse bg-gray-400 text-[7px] xl:text-[16.4px] md:text-[12px] text-gray-500"></p>
                              </div>
                            </div>
                          </div>
                          <div class="  flex items-center h-auto space-x-1">
                            <div class="w-16 h-4 animate-pulse bg-gray-400"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="w-full ">
                      <swiper :effect="'coverflow'" :initialSlide="1" :grabCursor="true" :centeredSlides="true" :slidesPerView="'auto'"
                         :coverflowEffect="{
                          rotate: 50,
                          stretch: 0,
                          depth: 100,
                          modifier: 1,
                          slideShadows: true,
                        }" :modules="modules" class=" swiper_enchere">
                        <swiper-slide v-for="j in 3" :key="j.id" class="animate-pulse bg-gray-400 lg:w-[262px] w-[238px] swiper-article-enchere rounded-md ml-2 mt-2 shadow shadow-[#ff9900] relative">

                        </swiper-slide>
                      </swiper>
                    </div>
                    <div class="w-full flex justify-between md:justify-start items-center space-x-10 ">
                      <div class="w-14 md:w-28 h-2 animate-pulse bg-gray-400 flex xl:space-x-2 space-x-1 ">
                        
                      </div>
                      <div class="w-14 md:w-16 h-2 animate-pulse bg-gray-400 flex xl:space-x-2 space-x-1 ">
                      </div>
                      <div class="w-14 md:w-32 h-2 animate-pulse bg-gray-400 flex xl:space-x-2 space-x-1 ">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="loadEnchere == false && encheres.length > 0" @scroll="loadInfinite" id="scrollEnchere" class="w-full h-full overflow-y-auto no-scrollbar">
                <div v-for="enchere in encheres" :key="enchere.id" class="w-full px-4 flex justify-center items-center">
                  <!-- debut du cadre pour la presentation des swiper celui avec le shadow  -->
                  <div class="h-full w-full p-3 relative border rounded-md shadow-lg space-y-2">
                    <div class="w-full">
                      <div
                        class="w-full h-[100%]  rounded-t-md justify-start items-center flex xl:space-x-3 space-x-2">
                        <div class="flex relative w-full justify-between space-x-1">
                          <div class="flex space-x-2">
                            <div class="leading-5 pt-1 h-auto flex items-center">
                              <div v-if="enchere.status == 'bientot'" class="bg-yellow-500 font-semibold flex-auto my-auto text-white p-1 md:p-2 rounded-md text-[10px] xl:text-[18px] w-max">{{ $t('bientot') }}...</div>
                              <div v-if="enchere.status == 'direct'" class="bg-green-500 font-semibold flex-auto my-auto text-white p-1 md:p-2 rounded-md text-[10px] xl:text-[18px] w-max">{{ $t('endirect') }}</div>
                              <div v-if="enchere.status == 'termine'" class="bg-red-500 font-semibold flex-auto my-auto text-white p-1 md:p-2 rounded-md text-[10px] xl:text-[18px] w-max">{{ $t('terminee') }}</div>
                            </div>
                            <div class="pt-1 xl:leading-6 leading-3 md:leading-4">
                              <p class="font-semibold xl:text-[16px] text-[8px] md:text-[12px]">
                                {{ enchere.titre }}
                              </p>
                              <p class="text-[7px] xl:text-[16.4px] md:text-[12px] text-gray-500">
                                <span v-for="(ville,index) in JSON.parse(enchere.ville)" :key="ville.id">{{ ville }}<span v-if="index < JSON.parse(enchere.ville).length - 1">, </span></span>
                              </p>
                            </div>
                          </div>
                          <button v-if="enchere.status == 'direct'" :class="user.status == 'block' ? 'opacity-50':'opacity-100'" :disabled="user.status == 'block'? true:false" @click="viewSalonEnchere(enchere)" class=" flex space-x-1 items-center">
                            <div class="h-auto flex items-centre">
                              <p class="font-semibold cursor-pointer text-[#ff9900] text-xs md:text-md w-max">
                                {{ $t('allezaudirect') }} 
                              </p>
                            </div>
                            <div class="h-auto flex items-centre w-5">
                              <img src="/icons/right.svg" alt="" class="w-5  md:w-6 md:h-6  text-[#ff9900] h-5">
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div v-if="enchere.articles.length > 0" class="w-full ">
                      <swiper :effect="'coverflow'" :initialSlide="Math.trunc((enchere.articles.length)/2)" :grabCursor="true" :centeredSlides="true" :slidesPerView="'auto'"
                        :navigation="true" :coverflowEffect="{
                          rotate: 50,
                          stretch: 0,
                          depth: 100,
                          modifier: 1,
                          slideShadows: true,
                        }" :modules="modules" class=" swiper_enchere">
                        <swiper-slide v-for="(article) in enchere.articles" :key="article.id" class="lg:w-[262px] w-[238px] swiper-article-enchere rounded-md ml-2 mt-2 shadow shadow-[#ff9900] relative">
                          <div class="w-full h-full shadow shadow-[#ff9900] relative">
                            <div class="w-full h-full">
                              <router-link to="" class="w-full h-full">
                                <div class="w-full h-[45%] relative">
                                  <swiper :slidesPerView="'auto'" :modules="modules" :freeMode="true" :loop="true" :autoplay="true">
                                    <swiper-slide v-for="(image) in JSON.parse(article.image)" :key="image.id" class="w-full h-full swiper-slide-image-article">
                                      <img class="w-full h-full object-cover object-center" :src="image"  srcset="">
                                    </swiper-slide>
                                  </swiper>
                                </div>
                                <div class="w-full h-[55%] px-2 relative">
                                  <div class=" w-full h-[41%]">
                                    <p class="text-[1rem] font-semibold">{{ article.marque ? (article.marque) : ''  }} {{ article.nom }}</p>
                                    <!-- ecran sm -->
                                    <p v-if="article.description.length > 200" class="mt-1 text-xs text-gray-700 text-justify"><span class="text-md font-bold">Description :</span> {{ article.description.substring(0,200) + '...' }}</p>
                                    <p v-if="article.description.length <= 200" class="mt-1 text-xs text-gray-700 text-justify"><span class="text-md font-bold">Description :</span> {{ article.description }}</p>
                                  </div>
                                  <div class="w-full justify-between flex absolute bottom-0 h-[25%]">
                                    <div class="flex space-x-2 h-full items-center">
                                      <div class="w-[1.5rem] h-[1.5rem] rounded-full">
                                        <img class="h-full" src="/icons/dollar.png" />
                                      </div>
                                      <div>
                                        <div class="flex space-x-1">
                                          <div class="h-auto flex items-center">
                                            <p class="text-[#FF9900]"> <span class="font-semibold">{{ transformAmount(article.prix) }}</span></p>
                                          </div>
                                          <div class="h-auto flex items-center">
                                            <svg class="h-6 fill-[#FF9900]" version="1.0" xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 433.000000 577.000000"
                                              preserveAspectRatio="xMidYMid meet">
                      
                                                  <g transform="translate(0.000000,577.000000) scale(0.100000,-0.100000)"
                                                  stroke="none">
                                                  <path d="M2248 5551 c-352 -49 -603 -368 -568 -719 16 -151 64 -290 185 -532
                                                  36 -71 65 -132 65 -135 0 -3 -13 -5 -28 -5 -69 0 -238 39 -531 121 -373 106
                                                  -480 129 -593 129 -105 0 -124 -11 -114 -65 11 -58 41 -80 124 -93 256 -38
                                                  496 -294 625 -668 79 -226 108 -444 108 -794 0 -598 -66 -944 -216 -1133 -59
                                                  -74 -96 -97 -158 -97 -81 0 -150 45 -177 114 -23 62 20 126 85 126 36 0 82 38
                                                  91 77 4 13 4 52 2 87 -9 145 -123 217 -341 216 -132 -1 -213 -43 -277 -142
                                                  -54 -83 -67 -156 -47 -259 45 -221 189 -377 393 -425 53 -12 101 -15 204 -11
                                                  156 5 251 30 358 94 58 34 156 125 178 165 8 15 39 13 409 -28 220 -25 401
                                                  -46 402 -48 6 -5 -28 -251 -48 -350 -44 -221 -106 -361 -199 -448 -62 -58
                                                  -128 -82 -230 -82 -167 -2 -264 88 -230 213 17 63 61 106 141 138 82 33 146
                                                  83 165 130 22 51 17 131 -9 178 -46 81 -202 128 -351 105 -136 -21 -248 -95
                                                  -329 -218 -105 -159 -148 -374 -102 -507 57 -165 214 -317 408 -395 138 -55
                                                  195 -65 387 -64 161 1 182 3 265 28 223 68 374 196 471 401 82 174 114 353
                                                  114 657 l0 196 63 7 c208 22 350 61 502 138 83 43 115 66 191 142 98 97 144
                                                  172 184 300 31 97 39 330 16 462 -20 115 -63 236 -118 327 -54 92 -174 211
                                                  -264 264 -103 60 -110 91 -35 141 250 161 192 565 -108 759 -70 46 -183 86
                                                  -281 101 -36 5 -162 13 -280 16 -118 3 -232 9 -254 13 l-38 7 -78 225 c-43
                                                  124 -81 234 -86 245 -5 13 9 5 40 -23 75 -69 124 -87 236 -87 87 0 100 3 163
                                                  33 200 98 307 324 252 532 -41 153 -166 306 -306 373 -124 60 -295 87 -431 68z
                                                  m-127 -1758 c75 -167 166 -410 156 -419 -3 -3 -57 -2 -120 2 l-115 7 -12 45
                                                  c-31 124 -110 284 -186 379 -19 23 -34 44 -34 47 0 3 63 6 140 6 l141 0 30
                                                  -67z m665 48 c60 -27 114 -80 140 -136 68 -144 -19 -271 -217 -318 -25 -6 -27
                                                  -4 -39 51 -12 53 -93 364 -106 405 -5 15 4 17 88 17 69 0 104 -5 134 -19z
                                                  m279 -840 c73 -33 127 -112 159 -232 68 -264 -18 -558 -223 -759 -64 -63 -116
                                                  -99 -126 -88 -3 3 -10 76 -15 164 -18 290 -46 543 -97 897 l-6 37 134 0 c108
                                                  0 142 -4 174 -19z m-676 -53 c43 -218 61 -463 61 -814 l0 -284 -350 0 c-192 0
                                                  -350 3 -350 7 0 4 20 45 44 92 83 161 170 405 230 641 30 121 32 136 17 141
                                                  -14 6 -14 8 2 14 14 6 17 20 17 71 0 48 3 64 14 64 9 0 16 18 20 54 7 54 8 55
                                                  44 59 20 2 83 4 139 5 l102 2 10 -52z m-309 -28 c0 -5 -4 -10 -10 -10 -5 0
                                                  -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"/>
                                                  </g>
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </router-link>
                            </div>
                          </div>
                        </swiper-slide>
                      </swiper>
                    </div>
                    <div class="w-full flex justify-between items-center space-x-10 ">
                      <p class="text-italic text-gray-500 xl:text-[14px] md:text-[10px] text-[6px] italic">{{ $t('debutele') }}
                        :{{ new Date(enchere.date).toLocaleDateString(`${langue}`) }} {{ enchere.heure }}</p>
                      <div class="flex xl:space-x-2 space-x-1 ">
                        <img src="/icons/user_groups.svg" alt="" class="w-6 h-6"> 
                        <p class="text-[14px] xl:text-[14px] hidden md:block"><span class="text-red-600 font-semibold">{{ $t('endirect') }}</span> <span class="font-semibold">{{ enchere.users_actif_count < 10 && enchere.users_actif_count > 0 ? '0' + enchere.users_actif_count:enchere.users_actif_count }}</span></p>
                        <p class="text-[14px] md:hidden block"><span class="text-red-600 font-semibold">{{ enchere.users_actif_count < 10 && enchere.users_actif_count > 0 ? '0' + enchere.users_actif_count:enchere.users_actif_count }}</span></p>
                      </div>
                      <div class="flex xl:space-x-2 space-x-1 ">
                        <div class="h-auto flex items-center">
                          <img src="/icons/box.svg" alt="" class="w-6 h-6 mt-1"> 
                        </div>
                        <div class="h-auto flex items-center">
                          <p class="text-[10px] xl:text-[16px] md:text-[12px] hidden md:block">
                            {{ $t('elementvendu') }} {{ enchere.articles.filter(item => item.status == 'vendu').length}}/{{ enchere.articles.length}}
                          </p>
                          <p class="text-[10px] xl:text-[16px] md:text-[12px] md:hidden block">
                            {{ $t('vendus') }} {{ enchere.articles.filter(item => item.status == 'vendu').length}}/{{ enchere.articles.length}}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="fin == false && scrollExec" class="w-full flex items-center">
                  <div class="chaotic-orbit mx-auto"></div>
                </div>
                <div class="w-full flex mt-1 text-gray-500" v-if="fin && encheres.length > 0" >
                  <p class="mx-auto" v-if="langue == 'fr'">Plus aucun éléments !</p>
                  <p class="mx-auto" v-if="langue == 'en'">No more elements !</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';

import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import "swiper/css/navigation";

//import './style.css';

// import required modules
import { Autoplay, EffectCoverflow, Pagination, Navigation } from 'swiper';
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Autoplay, EffectCoverflow, Pagination, Navigation],
    };
  },
  watch: {
    requestAccueil: {
      handler(newValue) {
        this.user = newValue[0]
      },
      deep: true
    },
    requestNbrEnchre: {
      handler(newValue) {
        this.nbr = newValue
      },
      deep: true
    },
  },
  data(){
    return{
      user:'',
      encheres:[],
      page:1,
      langue:'',
      nbr:0,
      scrollExec:false,
      fin:false,
      loadEnchere:false,
      nameSearch:'',
    }
  },
  mounted(){
    window.emitter.emit("HiddenModal",false) // faire disparaitre le lecteur sur les encheres
    this.requestAuth == 'NotAuth' ? this.$router.push('/'):''
    this.langue = localStorage.getItem('langue');
    this.$store.state.preview = ''
    this.user = this.requestAccueil[0]
    if(this.user.sexe == null && this.user.ville == null && this.user.description == null && this.user.date_naissance == null){
      this.$router.push('/profil');
    }

    if(this.$store.state.encheres.length > 0){
      this.encheres = this.$store.state.encheres
      this.nbr = this.$store.state.nbrEnchreDirect
      this.page = Math.ceil(this.$store.state.encheres.length/1) + 1
      this.$nextTick(() => {
        if(document.getElementById('scrollEnchere')){
          document.getElementById('scrollEnchere').scrollTop = this.$store.state.routerLastPosition['scrollEnchere'] 
        }  
      })
    }else{
      this.loadEnchere = true
      this.axios.get(this.requestHttp + 'view-encheres-actif'+'?page=' + this.page, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        },
      }).then(({ data }) => {
        this.loadEnchere = false
        this.encheres = data[0].data
        this.$store.state.encheres = this.encheres 
        this.$store.state.nbrEnchreDirect = data[1]
        this.page += 1
      })
      .catch((error) => {
        console.log(error)
      });
    }

  },
  methods:{
    viewSalonEnchere(enchere){
      this.$router.push({name:'salon_enchere', query:{id:this.$crypto(enchere.id), titre:enchere.titre} })
    },
    infiniteHandler(){
      this.axios.get(this.requestHttp + 'view-encheres-actif', {
        params: {
          mot:this.nameSearch,
          page:this.page,
        },
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        },
      }).then(({ data }) => {
        if(data[0].data.length > 0){
          this.page += 1
          this.encheres.push(...data[0].data)
          this.scrollExec = false 
        }else{
          this.fin = true
        }
        this.loadEnchere = false
      })
      .catch((error) => {
        console.log(error)
      });
    },
    loadInfinite(e){
      const max=e.target.scrollHeight //la partie que la bar de scroll doit parcourir + la hauteur de la bar de scroll
      const base=e.target.clientHeight //la hauteur de la bar de scroll
      const scrollY=e.target.scrollTop //la distance parcouru par la bar du scroll
      const delta=max-(base+scrollY)
      this.$store.dispatch('requestRouterLastPosition', {name:'scrollEnchere', scrollPosition:e.target.scrollTop})
      if(delta <= max * 50/100 && this.scrollExec == false){
        this.scrollExec = true
        this.infiniteHandler()
      }
    },
    transformAmount(value){
      var result = ''
      if(value > 0){
        var text = Math.round(value).toString()
        var countElement = ''
        for (let i = 1; i <= text.length; i++) {
          result = text[text.length - i] + result
          countElement += text[text.length - i]
          if(countElement.length < text.length && countElement.length%3 == 0){
            result = (localStorage.getItem('langue') == 'fr' ? ',':'.') + result
          }
        }
      }else{
        result = value
      }
      
      return result
    },
    searchRefresh(){
      if(this.nameSearch.length == 0){
        this.page = 1
        this.scrollExec = false
        this.fin = false
        this.loadEnchere = true 
        this.encheres = []
        this.infiniteHandler()
      }
    },
    search(){
      if(this.nameSearch.length > 0){
        this.page = 1
        this.scrollExec = false
        this.fin = false
        this.loadEnchere = true 
        this.encheres = []
        this.infiniteHandler()
      }
    },
  },
  computed:{
    requestAuth() {
      return this.$store.state.auth
    },
    requestHttp(){
      return this.$store.state.api
    },
    requestAccueil(){
      return this.$store.state.dataAccueil
    },
    requestFile(){
      return this.$store.state.apifile
    },
    requestNbrEnchre(){
      return this.$store.state.nbrEnchreDirect
    },
  }
}
</script>
  
<style>
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scrollbar {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}
.swiper_enchere {
  width: 100%;
  height: 100%;
  position:inherit !important;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.swiper-article-enchere {
  background-position: center;
  background-size: cover;
  width: 238px;
  height: 300px !important;
}


.swiper_enchere .swiper-button-next{
  height: 2.5rem;
  border-radius: 9999px;
  width: 2.5rem;
  text-align: center;
  right: 5px;
  color: #ffffff ;
  background: #FF9900 ;
  align-items: center;
}
.swiper_enchere .swiper-button-prev{
  height: 2.5rem;
  border-radius: 9999px;
  width: 2.5rem;
  right:55px !important;
  left: 0px !important;
  color: #ffffff ;
  background: #FF9900; 
  position: absolute;
}

* {
  scrollbar-width: thin;
  scrollbar-color: #FF9900 #ffffff;
}
*::-webkit-scrollbar{
    width: 10px;
}
*::-webkit-scrollbar-track{
    background-color: #ffffff;
    border-radius: 100vh;
}
*::-webkit-scrollbar-thumb{
    background: linear-gradient(transparent, #FF9900);
    border-radius: 100vh;
}
*::-webkit-scrollbar-thumb:hover{
    background: linear-gradient(transparent, #FF9900);
}
</style>